import React, { FC, useEffect, useState } from 'react';
import './ModalDefault.scss';
import { Col, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { BvIcon } from 'bevi-icon';
import { CompanyEnum } from '../../enums/Company/CompanyEnum';
import { useStyle } from '../../providers/StyleProvider';
import clsx from "clsx";

interface ModalDefaultProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    show: boolean;
    icon?: string;
    sizeModal?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
    onClose?: any;
    handleSubmit?: () => void;
    handleAdditionalSubmit?: () => void;
    handleCheckbox?: (checked: any) => void;
    buttonText?: string;
    buttonTextClose?: String;
    buttonTextAdditional?: string;
    checkboxText?: string;
    buttonBackgroundColor?: string;
    buttonAdditionalBackgroundColor?: string;
    buttonTextColor?: string;
    buttonAdditionalTextColor?: string;
    disabledSubmit?: boolean;
    disableAdditionalSubmit?: boolean;
    buttonIcon?: string;
    buttonAdditionalIcon?: string;
    showButtonSpinner?: boolean;
    showCheckbox?: boolean;
    showButtonAdditionalSpinner?: boolean;
    showFooter?: boolean;
    scrollable?: boolean;
    backdrop?: boolean | "static";
    backgroundColor?: string;
    classNameBody?: string;
    disableEsc?: boolean;
    disableCheckbox?: boolean;
    showCloseButton?: boolean;
    showCloseIcon?: boolean;
}

const ModalDefault: FC<ModalDefaultProps> = ({
    children,
    title,
    icon,
    sizeModal = 'xl',
    show,
    onClose,
    handleSubmit,
    handleAdditionalSubmit,
    handleCheckbox,
    buttonText,
    buttonTextClose,
    buttonTextAdditional,
    checkboxText,
    buttonBackgroundColor,
    buttonAdditionalBackgroundColor,
    buttonTextColor,
    buttonAdditionalTextColor,
    buttonIcon,
    buttonAdditionalIcon,
    disabledSubmit = false,
    disableCheckbox = true,
    disableAdditionalSubmit = false,
    showButtonSpinner = true,
    showButtonAdditionalSpinner = true,
    showFooter = true,
    showCheckbox = false,
    scrollable = false,
    backdrop = true,
    backgroundColor = "#F2F2F2",
    classNameBody = "",
    onScroll,
    disableEsc = false,
    showCloseButton = true,
    showCloseIcon = showCloseButton,
    ...rest
}) => {
    const { style } = useStyle();

    const handleOnClose = () => {
        !!onClose && onClose(false);
    }

    return (
        <Modal
            show={show}
            className={clsx("ModalDefault", rest?.className)}
            data-testid="ModalDefault"
            onHide={handleOnClose}
            size={sizeModal !== 'xxl' && sizeModal !== 'md' ? sizeModal : undefined}
            centered
            scrollable={scrollable}
            dialogClassName={`modal-${sizeModal}`}
            backdrop={backdrop}
            keyboard={!disableEsc}
        >
            <Modal.Header className="titleModal">
                <Modal.Title>
                    {
                        icon ?
                            <BvIcon
                                name={icon}
                                variant="solid"
                                className={`${style?.id === CompanyEnum.BEVI ? "text-light" : "text-primary"}`}
                                size={1.5}
                            />
                            : ""
                    }
                    <span className="mx-2" dangerouslySetInnerHTML={{ __html: title }}></span>
                </Modal.Title>
                {showCloseIcon && (
                    <button type="button" className="btn-close" data-dismiss="modal"
                        onClick={handleOnClose}>
                    </button>
                )}
                <div className="mask bg-primary opacity-9"></div>
            </Modal.Header>
            <Modal.Body className={`${!showFooter ? 'radius-bottom' : ''} ${classNameBody}`} style={{ padding: 30, backgroundColor: backgroundColor }}
                onScroll={onScroll}>
                <Row>
                    <Col md={12}>{children}</Col>
                </Row>
            </Modal.Body>
            {showFooter && (
                <Modal.Footer className='modal-footer'>
                    <Row className='w-100'>
                        <Col md={8}>
                            {showCheckbox && (
                                <div className="form-check" style={{ opacity: disableCheckbox ? '0.70' : '1' }}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="defaultCheck1"
                                        disabled={disableCheckbox}
                                        onChange={(e) => handleCheckbox && handleCheckbox(e)}
                                    />
                                    <label className="form-check-label">
                                        {checkboxText ? checkboxText : ""}
                                    </label>
                                </div>
                            )}
                        </Col>
                        <Col md={4} className="d-flex justify-content-end">
                            {handleAdditionalSubmit && (
                                <button type="button"
                                    className={`btn btn-text me-1 ${!!buttonAdditionalBackgroundColor ? buttonAdditionalBackgroundColor : 'btn-primary'} ${!!buttonAdditionalTextColor ? buttonAdditionalTextColor : ''}`}
                                    onClick={handleAdditionalSubmit}
                                    disabled={disableAdditionalSubmit}>
                                    {disableAdditionalSubmit && showButtonAdditionalSpinner && (
                                        <FontAwesomeIcon className="me-2" icon={faSpinner} spin />
                                    )}

                                    <i className={`${!!buttonAdditionalIcon ? buttonAdditionalIcon : ''}`}></i>
                                    <>{!!buttonTextAdditional ? buttonTextAdditional : 'Salvar'}</>
                                </button>
                            )}

                            {showCloseButton && (
                                <button type="button" className="btn btn-default btn-text me-1" onClick={handleOnClose}>
                                    {buttonTextClose ? buttonTextClose : 'Fechar'}
                                </button>
                            )}

                            {handleSubmit && (
                                <button type="button"
                                    className={`btn btn-text text-nowrap ms-1 ${!!buttonBackgroundColor ? buttonBackgroundColor : 'btn-primary'} ${!!buttonTextColor ? buttonTextColor : ''}`}
                                    onClick={handleSubmit}
                                    disabled={disabledSubmit}>
                                    {disabledSubmit && showButtonSpinner && (
                                        <FontAwesomeIcon className="me-2" icon={faSpinner} spin />
                                    )}

                                    <i className={`${!!buttonIcon ? buttonIcon : ''}`}></i>
                                    <>{!!buttonText ? buttonText : 'Salvar'}</>
                                </button>
                            )}
                        </Col>
                    </Row>
                </Modal.Footer>
            )}
        </Modal>
    );
}

export default ModalDefault;
